import { render, staticRenderFns } from "./vendor-select-modal.vue?vue&type=template&id=0023eae2&scoped=true"
import script from "./vendor-select-modal.vue?vue&type=script&lang=js"
export * from "./vendor-select-modal.vue?vue&type=script&lang=js"
import style0 from "./vendor-select-modal.vue?vue&type=style&index=0&id=0023eae2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0023eae2",
  null
  
)

export default component.exports